var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3242_56975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 8.04543C15.9532 12.4933 12.35 16.0404 7.91853 15.9997C3.46633 15.9589 -0.0474727 12.326 0.000485104 7.81239C0.0470113 3.50107 3.71256 -0.0432083 8.0803 0.000398124C12.4781 0.0447195 16.0449 3.66763 15.9998 8.04472V8.04543ZM6.64443 7.07322C7.15979 7.04034 7.23925 7.13756 7.10826 7.6444C7.03668 7.92033 6.96224 8.19555 6.8928 8.47221C6.63369 9.49731 6.34523 10.5167 6.12763 11.5511C5.94224 12.4311 6.54923 13.0981 7.44826 13.0866C8.33798 13.0759 9.436 12.2695 9.70657 11.4067C9.73663 11.3109 9.6536 11.1794 9.62282 11.065C9.50972 11.0957 9.37873 11.1 9.28854 11.1629C9.13465 11.2695 9.02657 11.4689 8.86337 11.5275C8.65865 11.6011 8.39381 11.634 8.20269 11.5604C8.11966 11.5282 8.10105 11.1729 8.14686 10.9885C8.49617 9.58167 8.87124 8.18126 9.23415 6.77727C9.33507 6.38624 9.23343 6.28187 8.82973 6.32905C8.29718 6.39125 7.76392 6.44415 7.23137 6.50563C6.93575 6.53994 6.63727 6.5671 6.34809 6.63215C6.26792 6.65003 6.16055 6.79943 6.16771 6.87878C6.17487 6.95527 6.30514 7.03963 6.39891 7.0818C6.46619 7.11183 6.56211 7.07823 6.64586 7.07179L6.64443 7.07322ZM9.88551 4.09869C9.88623 3.42172 9.36442 2.90559 8.68514 2.91131C8.02804 2.91631 7.51482 3.43387 7.51339 4.09297C7.51124 4.76065 8.04594 5.29036 8.7152 5.28464C9.368 5.27892 9.8848 4.75493 9.88551 4.09869Z",
    fill: "#F69321"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3242_56975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.c9ec833c0efc23ca4021fddaf27c9b52.svg";
export { ForwardRef as ReactComponent };